import { createSelectListCollection } from '../../../components/select';
import type {
  CloudInventorySurfaceAccountBodyDto,
  CloudInventorySurfaceAttachmentDto,
  CloudInventorySurfaceProviderBodyDto,
  UpdateCloudAccountPolicyBodyDto,
} from '@terra/shared-contracts-external-network';

export type CloudAccountAutoScope =
  UpdateCloudAccountPolicyBodyDto['autoScope'];

export const AUTO_SCOPE_OPTIONS: CloudAccountAutoScope[] = [
  'IN_SCOPE',
  'PENDING',
  'OUT_OF_SCOPE',
];

export const STATUS_COLOR: Record<
  NonNullable<CloudInventorySurfaceAttachmentDto['status']>,
  string
> = {
  ACTIVE: 'green',
  SYNC_ERROR: 'red',
  DISCONNECTED: 'gray',
};

export const attachmentKey = (
  attachment: CloudInventorySurfaceAttachmentDto,
): string =>
  attachment.accountId ??
  `${attachment.provider}:${attachment.connectionId ?? 'pending'}`;

export const toSyncBody = (
  attachment: CloudInventorySurfaceAttachmentDto,
): CloudInventorySurfaceProviderBodyDto => ({
  provider: attachment.provider,
  ...(attachment.accountId ? { accountId: attachment.accountId } : {}),
  ...(attachment.connectionId ? { connectionId: attachment.connectionId } : {}),
});

export const toAccountBody = (
  attachment: CloudInventorySurfaceAttachmentDto,
): CloudInventorySurfaceAccountBodyDto | null => {
  if (!attachment.accountId) {
    return null;
  }

  return {
    provider: attachment.provider,
    accountId: attachment.accountId,
    ...(attachment.connectionId
      ? { connectionId: attachment.connectionId }
      : {}),
  };
};

export const resolveAutoScope = (
  autoScope: CloudInventorySurfaceAttachmentDto['autoScope'],
): CloudAccountAutoScope =>
  AUTO_SCOPE_OPTIONS.find((option) => option === autoScope) ?? 'PENDING';

export const createAutoScopeCollection = ({
  labels,
}: {
  labels: Record<CloudAccountAutoScope, string>;
}) =>
  createSelectListCollection({
    items: AUTO_SCOPE_OPTIONS.map((option) => ({
      value: option,
      label: labels[option],
    })),
  });

export type AutoScopeCollection = ReturnType<typeof createAutoScopeCollection>;
